module.exports = __webpack_public_path__ + "img/好的.6345172d.png";